module.exports = __webpack_public_path__ + "static/media/do-not-sync.26467ce0.png";